import { Credit, Debit, LedgerEntry } from '@sparkplug/lib';

export function isCredit(entry: LedgerEntry): entry is Credit {
    return entry.amount > 0;
}

export function isDebit(entry: LedgerEntry): entry is Debit {
    return entry.amount < 0;
}
